/* Ellips "Grow" product page (sections/el-grow.liquid), 2026-10-01.
   The page sells without this file (a real /cart/add form). This adds: one-time / Member price switch, add to cart
   through window.ElCart (the cart drawer, assets/el-cart.js), the gallery progress line and thumbnails, slide-in
   drawers, "Read more", the Member bundle card, quick add on the product cards, slider arrows and the phone sticky bar. */
(function () {
  'use strict';
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const reduced = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const smooth = () => (reduced() ? 'auto' : 'smooth');

  /* page_variant: 'grow', or the page's data-elg-page (the offer page sections/el-home.liquid sends 'home'). */
  function track(name, props) {
    const variant = (document.querySelector('[data-elg-page]') || { dataset: {} }).dataset.elgPage || 'grow';
    try { if (window.posthog && typeof window.posthog.capture === 'function') window.posthog.capture(name, Object.assign({ page_variant: variant }, props || {})); } catch (e) { /* analytics never blocks */ }
  }

  /* One-time vs subscription, size (50 or 100 capsules = 1 or 2 jars per delivery) and frequency. The plan select is
     disabled for one-time so the form posts no selling_plan; the hidden quantity follows the size. Prices, the save pill,
     the plan price line and the sticky bar are recomputed from cents (option data-price, root data-once-cents). */
  function initPurchase(root) {
    const radios = $$('[data-elg-purchase]', root);
    const plan = $('[data-elg-plan]', root);
    const sizes = $$('[data-elg-size]', root);
    const qty = $('[data-elg-qty]', root);
    const variant = $('[data-elg-variant]', root);
    const planRadio = radios.find((x) => x.value === 'plan');
    const shipLabel = $('[data-elg-ship-label]', root);
    /* same local style as snippets/el-money: kronor, koruna and złoty with space thousands, no ",00" on whole kr / Kč */
    const fmt = (c) => {
      let t = window.ellipsFormatMoney ? window.ellipsFormatMoney(c) : (c / 100).toFixed(2);
      if (/(kr|Kč|zł)/.test(t)) {
        t = t.replace(/(\d)\.(?=\d{3})/g, '$1\u00a0');
        t = t.replace(/,00(?=\s?(kr|Kč))/, '');
        t = t.replace(/\s(kr|Kč|zł)/, '\u00a0$1');
      }
      return t;
    };
    let planTouched = false;
    const mode = () => { const r = radios.find((x) => x.checked); return r ? r.value : 'once'; };
    const size = () => {
      const o = sizes.length ? sizes[0].selectedOptions[0] : null;
      return o ? { key: o.value, isTry: o.dataset.try === '1', variant: o.dataset.variant, qty: Number(o.dataset.qty || 1), once: Number(o.dataset.once || root.dataset.onceCents || 0), was: Number(o.dataset.was || 0) }
               : { key: '1', isTry: false, variant: variant && variant.value, qty: 1, once: Number(root.dataset.onceCents || 0) };
    };
    /* point each frequency option at the plan of the chosen product (jar plans, or the try size's own plans) */
    const retarget = (sz) => {
      if (!plan) return false;
      let any = false;
      $$('option', plan).forEach((o) => {
        if (!o.dataset.jid) { any = true; return; }
        const id = sz.isTry ? o.dataset.sid : o.dataset.jid;
        o.disabled = !id;
        if (id) { o.value = id; any = true; }
      });
      if (plan.selectedOptions[0] && plan.selectedOptions[0].disabled) { const ok = $$('option', plan).find((o) => !o.disabled); if (ok) plan.value = ok.value; }
      return any;
    };
    const recommend = () => {
      if (!plan) return;
      const sz = size();
      const rec = String(sz.key === '2' ? plan.dataset.rec2 : plan.dataset.rec1);
      $$('option', plan).forEach((o) => {
        if (!o.dataset.label) return;
        o.textContent = o.dataset.label + (o.dataset.k === rec && plan.dataset.recLabel ? ' ' + plan.dataset.recLabel : '');
        if (!planTouched && o.dataset.k === rec && !o.disabled) plan.value = o.value;
      });
    };
    const render = (source) => {
      const sz = size();
      const planOk = retarget(sz);
      root.setAttribute('data-size', sz.isTry ? 't' : 'jar');
      root.setAttribute('data-try-plan', sz.isTry && !planOk ? 'no' : 'yes');
      if (planRadio) {
        planRadio.disabled = !planOk;
        if (!planOk && planRadio.checked) { const o = radios.find((x) => x.value === 'once'); if (o) o.checked = true; }
      }
      const m = mode();
      root.setAttribute('data-plan', m === 'plan' ? 'on' : 'off');
      if (plan) plan.disabled = m !== 'plan';
      if (variant && sz.variant) variant.value = sz.variant;
      if (qty) qty.value = String(sz.qty);
      const opt = plan && plan.selectedOptions[0];
      const pp = opt ? Number((sz.isTry ? opt.dataset.sprice : opt.dataset.price) || 0) : 0;
      const set = (sel, txt) => $$(sel, root).forEach((e) => { e.textContent = txt; });
      if (sz.once) { set('[data-elg-once-price]', fmt(sz.once * sz.qty)); set('[data-elg-plan-was]', fmt(sz.once * sz.qty)); }
      /* crossed-out one-time price (compare-at, el-grow.liquid p_was): shown for the jar sizes, hidden for the try size */
      const onceWas = $('[data-elg-once-was]', root);
      if (onceWas && sz.was !== undefined) {
        const on = sz.was > sz.once;
        const pill = $('[data-elg-once-save]', root);
        onceWas.style.display = on ? '' : 'none';
        if (pill) pill.style.display = on ? '' : 'none';
        if (on) {
          onceWas.textContent = fmt(sz.was * sz.qty);
          if (pill) pill.textContent = pill.dataset.tpl.replace('[pct]', Math.floor(((sz.was - sz.once) * 100) / sz.was));
        }
      }
      if (pp) {
        set('[data-elg-plan-price]', fmt(pp * sz.qty));
        const save = $('[data-elg-save]', root);
        if (save && sz.once) save.textContent = save.dataset.tpl.replace('[pct]', Math.floor(((sz.once - pp) * 100) / sz.once));
        const note = $('[data-elg-plan-note]', root);
        const tpl = sz.isTry ? (plan.dataset.noteTryTpl || plan.dataset.noteTpl) : plan.dataset.noteTpl;
        if (note && tpl) note.textContent = tpl.replace('[price]', fmt(pp));
      }
      if (shipLabel) shipLabel.textContent = sz.isTry && shipLabel.dataset.try ? shipLabel.dataset.try : shipLabel.dataset.jar;
      const sticky = $('[data-elg-sticky-price]', root);
      if (sticky) sticky.textContent = fmt((m === 'plan' && pp ? pp : sz.once) * sz.qty);
      if (source) track('grow_purchase_option', { option: m, size: sz.key, plan: m === 'plan' && plan ? plan.value : null, source });
    };
    const setMode = (m, source) => { const r = radios.find((x) => x.value === m); if (r) r.checked = true; render(source); };
    radios.forEach((r) => r.addEventListener('change', () => r.checked && render('radio')));
    sizes.forEach((sel) => sel.addEventListener('change', () => {
      sizes.forEach((o) => { if (o !== sel) o.value = sel.value; });
      recommend(); render('size');
    }));
    if (plan) plan.addEventListener('change', () => { planTouched = true; render('frequency'); });
    /* the size and frequency fields sit inside the option labels: clicking them must not re-target the radio */
    $$('.elg-opt select', root).forEach((sel) => sel.addEventListener('click', (e) => e.stopPropagation()));
    recommend();
    render();
    window.addEventListener('pageshow', () => render());
    root._elgSet = setMode;
  }

  function initForm(root) {
    const form = $('[data-elg-form]', root);
    if (!form) return;
    const err = $('[data-elg-error]', root);
    form.addEventListener('submit', (event) => {
      const cart = window.ElCart;
      if (!cart || typeof cart.add !== 'function') return;
      event.preventDefault();
      if (root.classList.contains('is-busy')) return;
      const item = { id: Number($('[data-elg-variant]', form).value), quantity: Number(($('[data-elg-qty]', form) || {}).value || 1) };
      const plan = $('[data-elg-plan]', form);
      if (plan && !plan.disabled && plan.value) item.selling_plan = Number(plan.value);
      root.classList.add('is-busy');
      if (err) err.hidden = true;
      track('grow_add_to_cart', { plan: !!item.selling_plan });
      Promise.resolve(cart.add([item]))
        .catch((e) => { if (err) { err.textContent = (e && e.message) || ''; err.hidden = !err.textContent; } })
        .finally(() => root.classList.remove('is-busy'));
    });
  }

  /* Gallery: progress line + thumbnails (phone), keyboard arrows. */
  function initGallery(root) {
    const trackEl = $('[data-elg-track]', root);
    if (!trackEl) return;
    const slides = $$('.elg-slide', trackEl);
    const bar = $('[data-elg-bar]', root);
    const thumbs = $$('[data-elg-thumb]', root);
    const count = slides.length || 1;
    /* data-elg-pair (el-home, photos right on desktop): two photos in view, both thumbnails highlighted (2026-10-20). */
    const pair = !!trackEl.closest('[data-elg-pair]');
    let current = 0;
    let shown = 1;
    const update = () => {
      let idx;
      let vis = 1;
      if (pair && slides.length > 1) {
        const step = (slides[1].offsetLeft - slides[0].offsetLeft) || trackEl.clientWidth;
        vis = Math.max(1, Math.round(trackEl.clientWidth / step));
        idx = Math.max(0, Math.min(count - vis, Math.round(trackEl.scrollLeft / step)));
      } else {
        const max = trackEl.scrollWidth - trackEl.clientWidth;
        const ratio = max > 0 ? trackEl.scrollLeft / max : 0;
        idx = Math.round(ratio * (count - 1));
      }
      if (bar) { bar.style.width = (100 / count) + '%'; bar.style.transform = 'translateX(' + (idx * 100) + '%)'; }
      if (idx !== current || vis !== shown) {
        const moved = idx !== current;
        current = idx;
        shown = vis;
        thumbs.forEach((t, i) => t.classList.toggle('is-active', i >= idx && i < idx + vis));
        const active = thumbs[idx];
        if (active && active.parentElement) active.parentElement.scrollTo({ left: active.offsetLeft - 16, behavior: smooth() });
        if (moved) track('grow_gallery_slide', { slide: idx + 1 });
      }
    };
    let raf = 0;
    trackEl.addEventListener('scroll', () => { cancelAnimationFrame(raf); raf = requestAnimationFrame(update); }, { passive: true });
    if (pair) window.addEventListener('resize', () => { cancelAnimationFrame(raf); raf = requestAnimationFrame(update); });
    thumbs.forEach((t, i) => t.addEventListener('click', () => { const s = slides[i]; if (s) trackEl.scrollTo({ left: s.offsetLeft - trackEl.offsetLeft, behavior: smooth() }); }));
    trackEl.addEventListener('keydown', (e) => {
      if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
      e.preventDefault();
      const step = slides[0] ? slides[0].getBoundingClientRect().width : trackEl.clientWidth;
      trackEl.scrollBy({ left: e.key === 'ArrowRight' ? step : -step, behavior: smooth() });
    });
    update();
  }

  /* Slide-in drawers: <dialog class="elg-drawer">, opened by [data-elg-open="id"]. */
  function initDrawers(root) {
    const open = (id, opener) => {
      const d = document.getElementById(id);
      if (!d || typeof d.showModal !== 'function') return;
      d.classList.add('is-entering');
      d.showModal();
      requestAnimationFrame(() => requestAnimationFrame(() => d.classList.remove('is-entering')));
      d._opener = opener;
      track('grow_drawer_open', { drawer: id.split('-')[0] });
    };
    const close = (d) => {
      if (!d.open) return;
      if (reduced()) { d.close(); return; }
      d.classList.add('is-entering');
      setTimeout(() => { d.close(); d.classList.remove('is-entering'); }, 260);
    };
    root.addEventListener('click', (e) => {
      const o = e.target.closest('[data-elg-open]');
      if (o) { e.preventDefault(); open(o.getAttribute('data-elg-open'), o); return; }
      const x = e.target.closest('[data-elg-close]');
      if (x) { close(x.closest('dialog')); return; }
      if (e.target.matches('dialog.elg-drawer')) close(e.target); /* click on the backdrop */
    });
    $$('dialog.elg-drawer', root).forEach((d) => d.addEventListener('close', () => { if (d._opener) d._opener.focus({ preventScroll: true }); }));
  }

  /* "Read more" under the short description jumps to About and opens it; the About toggle opens/closes. */
  function initAbout(root) {
    const about = $('[data-elg-about]', root);
    const toggle = about && $('[data-elg-more]', about);
    const setOpen = (on) => { if (!about) return; about.classList.toggle('is-open', on); if (toggle) toggle.setAttribute('aria-expanded', on ? 'true' : 'false'); };
    if (toggle) toggle.addEventListener('click', () => setOpen(!about.classList.contains('is-open')));
    const jump = $('[data-elg-readmore]', root);
    if (jump && about) jump.addEventListener('click', () => { about.scrollIntoView({ behavior: smooth(), block: 'start' }); track('grow_read_more'); });
  }

  /* Member bundle card: picks the Member price and brings the buy box into view. */
  function initBundle(root) {
    const card = $('[data-elg-choose-plan]', root);
    if (!card) return;
    card.addEventListener('click', () => {
      if (root._elgSet) root._elgSet('plan', 'bundle');
      const buy = $('[data-elg-buy]', root);
      if (buy && window.matchMedia('(max-width: 989px)').matches) buy.scrollIntoView({ behavior: smooth(), block: 'start' });
      const plan = $('.elg-opt--plan', root);
      if (plan) { plan.classList.add('is-flash'); setTimeout(() => plan.classList.remove('is-flash'), 900); }
    });
  }

  /* Quick add on "Frequently bought together" cards: one-time, through the cart drawer. */
  function initQuickAdd(root) {
    root.addEventListener('click', (e) => {
      const b = e.target.closest('[data-elg-quick]');
      if (!b) return;
      const cart = window.ElCart;
      if (!cart || typeof cart.add !== 'function') return;
      b.disabled = true;
      track('grow_quick_add', { variant: b.getAttribute('data-elg-quick') });
      Promise.resolve(cart.add([{ id: Number(b.getAttribute('data-elg-quick')), quantity: 1 }]))
        .then(() => { b.classList.add('is-done'); setTimeout(() => b.classList.remove('is-done'), 1500); })
        .catch(() => {})
        .finally(() => { b.disabled = false; });
    });
  }

  /* Horizontal scrollers: arrows page by one item; a thin progress line follows the scroll. */
  function initScrollers(root) {
    $$('[data-elg-scroller]', root).forEach((sc) => {
      const block = sc.closest('.elg-block');
      const prev = block && $('[data-elg-prev]', block);
      const next = block && $('[data-elg-next]', block);
      const step = () => { const first = sc.firstElementChild; return first ? first.getBoundingClientRect().width + 16 : sc.clientWidth; };
      if (prev) prev.addEventListener('click', () => sc.scrollBy({ left: -step(), behavior: smooth() }));
      if (next) next.addEventListener('click', () => sc.scrollBy({ left: step(), behavior: smooth() }));
      const bar = block && $('[data-elg-scrollbar]', block);
      if (bar) {
        const upd = () => {
          const max = sc.scrollWidth - sc.clientWidth;
          const w = Math.min(100, sc.scrollWidth ? (sc.clientWidth / sc.scrollWidth) * 100 : 100);
          bar.style.width = w + '%';
          bar.style.transform = 'translateX(' + (max > 0 ? (sc.scrollLeft / max) * ((100 - w) / w) * 100 : 0) + '%)';
        };
        sc.addEventListener('scroll', upd, { passive: true });
        window.addEventListener('resize', upd);
        upd();
      }
    });
  }


  /* Synced carousels (Results, Featured in), as on Hairlust: the photo nearest the middle is active and its text shows. */
  function initSync(root) {
    $$('[data-elg-sync]', root).forEach((box) => {
      const tr = $('[data-elg-sync-track]', box);
      if (!tr) return;
      const slides = $$('.elg-sync__slide', tr);
      const texts = $$('[data-elg-sync-text]', box);
      let cur = -1;
      const activate = (i) => {
        if (i === cur) return;
        cur = i;
        slides.forEach((s, k) => s.classList.toggle('is-active', k === i));
        texts.forEach((t, k) => t.classList.toggle('is-active', k === i));
      };
      const nearest = () => {
        const mid = tr.getBoundingClientRect().left + tr.clientWidth / 2;
        let best = 0, dist = Infinity;
        slides.forEach((s, k) => { const r = s.getBoundingClientRect(); const d = Math.abs(r.left + r.width / 2 - mid); if (d < dist) { dist = d; best = k; } });
        return best;
      };
      const go = (i) => {
        const s = slides[Math.max(0, Math.min(slides.length - 1, i))];
        if (!s) return;
        const r = s.getBoundingClientRect(), t = tr.getBoundingClientRect();
        const dx = r.left + r.width / 2 - (t.left + tr.clientWidth / 2);
        /* Photo already in place (first/last): a sub-pixel move made Chrome's snapping jump a whole photo, so the back
           arrow on the first photo went forward (2026-10-26, build/press-arrows-1026-se). */
        if (Math.abs(dx) < 2) return;
        tr.scrollBy({ left: dx, behavior: smooth() });
      };
      let raf = 0;
      tr.addEventListener('scroll', () => { cancelAnimationFrame(raf); raf = requestAnimationFrame(() => activate(nearest())); }, { passive: true });
      slides.forEach((s, k) => s.addEventListener('click', () => go(k)));
      const prev = $('[data-elg-prev]', box), next = $('[data-elg-next]', box);
      if (prev) prev.addEventListener('click', () => go(cur - 1));
      if (next) next.addEventListener('click', () => go(cur + 1));
      activate(0);
    });
  }

  /* Phone sticky bar: on once the form's own button has scrolled above the window. Languages in STICKY_EARLY
     (2026-10-14: English only) also show it from the first screen, while the button is still below; off only while
     the button itself is visible. */
  const STICKY_EARLY = ['en'];
  function initSticky(root) {
    const bar = $('[data-elg-sticky]', root);
    const atc = $('[data-elg-atc]', root);
    if (!bar || !atc || !('IntersectionObserver' in window)) return;
    const lang = String((window.Shopify && window.Shopify.locale) || document.documentElement.lang || '').slice(0, 2).toLowerCase();
    const early = STICKY_EARLY.includes(lang);
    let above = false;
    const io = new IntersectionObserver(([en]) => {
      above = !en.isIntersecting && (early || en.boundingClientRect.top < 0);
      bar.classList.toggle('is-on', above);
      bar.setAttribute('aria-hidden', above ? 'false' : 'true');
      const btn = $('button', bar); if (btn) btn.tabIndex = above ? 0 : -1;
    });
    io.observe(atc);
  }

  /* Desktop: keep the sticky buy box below a sticky header. */
  function initHeaderOffset(root) {
    const header = document.querySelector('.el-section-header, .section-header, header.el-header');
    const setTop = () => {
      let h = 0;
      if (header) {
        const pos = getComputedStyle(header).position;
        if (pos === 'sticky' || pos === 'fixed') h = Math.max(0, header.getBoundingClientRect().bottom);
      }
      root.style.setProperty('--el-header-sticky', h + 'px');
    };
    setTop();
    window.addEventListener('resize', setTop);
    window.addEventListener('scroll', () => { if (header) setTop(); }, { passive: true });
  }

  function init(root) {
    if (root._elgInit) return;
    root._elgInit = true;
    initPurchase(root);
    initForm(root);
    initGallery(root);
    initDrawers(root);
    initAbout(root);
    initBundle(root);
    initQuickAdd(root);
    initScrollers(root);
    initSync(root);
    initSticky(root);
    initHeaderOffset(root);
    track('grow_page_view');
  }

  const boot = () => $$('[data-elg]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
